export default __webpack_public_path__ + "static/media/image03.17db07e2.jfif";